<template>
    <div class="account-visitor-side-panel">
        <account-visitor-card-content
            :id="activeId"
            ref="accountVisitorCardContent"
            :kind="kind"
            :delay="400"
            class="account-visitor-side-panel__card"
            :name="name"
            :is-salesforce-sourced="isSalesforceSourced"
            :preset-user-obj="presetUserObj"
            :hide-manage-metadata="hideManageMetadata" />
    </div>
</template>

<script>
import AccountVisitorCardContent from '@/common/account-visitor-hover-card/account-visitor-card-content/account-visitor-card-content.vue';

export default {
    name: 'AccountVisitorSidePanel',
    components: {
        AccountVisitorCardContent,
    },
    props: {
        kind: {
            type: String,
            default: 'account',
        },
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            default: '',
        },
        presetUserObj: {
            type: [Object, null],
            default: null,
        },
        isSalesforceSourced: {
            type: Boolean,
            default: false,
        },
        hideManageMetadata: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            activeId: '',
        };
    },
    watch: {
        id: {
            async handler () {
                this.handleChange();
            },
            immediate: true,
        },
    },
    methods: {
        async handleChange () {
            if (this.id === null || this.id === undefined) return;
            this.activeId = this.id;
            await this.$nextTick();
            if (this.$refs.accountVisitorCardContent) {
                this.$refs.accountVisitorCardContent.setFetchingMetadata(false);
                this.$refs.accountVisitorCardContent.showHandle();
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';
.account-visitor-side-panel {
    height: 400px;
    width: 333px;
    padding: 16px;
    &__empty {
        width: 333px;
        height: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    &__empty-text {
        line-height: 150%;
        text-align: center;
        color: var(--palette-gray-70);
    }
    &__card {
        padding: 16px;
    }
}
</style>
